import { useEffect, useRef } from 'react';

const stack = [];

function onDocumentKeydown(e) {
  if (e.key !== 'Escape') return;
  if (stack.length === 0) return;
  e.preventDefault();
  e.stopPropagation();
  stack[stack.length - 1]();
}

let listenerAttached = false;

function ensureListener() {
  if (listenerAttached) return;
  document.addEventListener('keydown', onDocumentKeydown, true);
  listenerAttached = true;
}

function removeListenerIfEmpty() {
  if (stack.length === 0 && listenerAttached) {
    document.removeEventListener('keydown', onDocumentKeydown, true);
    listenerAttached = false;
  }
}

/**
 * Registers an Escape handler while mounted and `enabled`.
 * Nested overlays: the most recently mounted registration runs first (LIFO).
 */
export function useRegisterTopEscapeClose(onClose, enabled = true) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!enabled) return undefined;
    const entry = () => onCloseRef.current();
    stack.push(entry);
    ensureListener();
    return () => {
      const i = stack.lastIndexOf(entry);
      if (i !== -1) stack.splice(i, 1);
      removeListenerIfEmpty();
    };
  }, [enabled]);
}
